// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__yZEQv","active":"Footer_active__vI7-j"};